const API_URL = 'device'

export const state = () => ({
  waste_company_devices: [],
  assign_history: {
    items: [],
  },
  device: {},
})

export const getters = {
  get: state => waste_company_device_id => {
    return state.waste_company_devices.find(
      waste_company_device => waste_company_device.id === parseInt(waste_company_device_id)
    )
  },
  getAssignHistory: state => {
    return state.assign_history
  },
  getDevice: state => {
    return state.device
  },
}

export const mutations = {
  PUSH_OR_REPLACE_WASTE_COMPANY_DEVICE(state, new_waste_company_device) {
    let waste_company_device_index = state.waste_company_devices.findIndex(
      waste_company_device => waste_company_device.id === parseInt(new_waste_company_device.id)
    )

    if (waste_company_device_index >= 0) {
      state.waste_company_devices.splice(waste_company_device_index, 1, new_waste_company_device)
    } else {
      state.waste_company_devices.push(new_waste_company_device)
    }
  },
  REMOVE_WASTE_COMPANY_DEVICE(state, waste_company_device_id) {
    let waste_company_device_index = state.waste_company_devices.findIndex(
      waste_company_device => waste_company_device.id === parseInt(waste_company_device_id)
    )

    state.waste_company_devices.splice(waste_company_device_index, 1)
  },
  SET_ASSIGN_HISTORY(state, history) {
    state.assign_history = history
  },
  SET_DEVICE(state, device) {
    state.device = device
  },
}

export const actions = {
  async fetch({ commit }, device_id) {
    let { data: device } = await useApi(`${API_URL}/${device_id}`)

    commit('SET_DEVICE', device.value)

    return device.value
  },
  async update({ commit }, device) {
    let { data } = await useApi(`${API_URL}/${device.id}`, { method: 'put', body: device })
    device = data.value
    return device
  },
  async delete({ commit }, device_id) {
    const { error } = await useApi(`${API_URL}/${device_id}`, { method: 'delete' })

    if (error.value) {
      throw error.value
    }

    return true
  },
  async assign({ commit }, { device_id, assignment }) {
    const { data, error } = await useApi(`${API_URL}/${device_id}/assign`, { method: 'put', body: assignment })

    console.log([data.value, error.value])

    if (error.value) {
      console.log('>>', error.value)
      throw error.value
    }
    console.log('####', data.value)
    return true
  },
  async unassign({ commit }, device_id) {
    const { error } = await useApi(`${API_URL}/${device_id}/unassign`, { method: 'put' })

    if (error.value) {
      throw error.value
    }

    return true
  },
  async fetchAssignHistory({ commit }, { device_id, params }) {
    let { data: assignHistory } = await useApi(`${API_URL}/${device_id}/assign-history`, {
      query: params,
    })

    commit('SET_ASSIGN_HISTORY', assignHistory.value)

    return assignHistory.value
  },
  async updateNote({ commit }, { device_id, device_history_id, note }) {
    await useApi(`${API_URL}/${device_id}/assign-history/${device_history_id}`, { method: 'put', body: note })
  },
}
